import { ObservationEntity } from '../../../../../coaching-base/config';
import { BehaviourItem } from '../../../../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../../../../coaching-tags/models/subbehaviour.coaching.model';
import { createAction } from '../../../../../store.model';
import { Chat, ChatMessage } from '../../../../../teams-call';
import { ActionType } from '../teamschat-transcript-dialog.action';

export interface Reload {
    chat: Chat;
    messages: ChatMessage[];
    behaviourId: number;
    subBehaviourId: number;
}

export const reload = createAction<ActionType, Reload>(
    ActionType.COACHING_DETAIL__TCTD__RELOAD,
);

export interface ReloadResult extends Reload {
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];
    observationConfig?: ObservationEntity;
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.COACHING_DETAIL__TCTD__RELOAD_RESULT,
);
